import UserSession from '../shared-campaign/utils/class/UserSession'
import { axiosInstance } from '../shared/services/axios-instance'
import * as endpoints from './../constants/api-constants'

export default class CollegeService {
  static getIdToken() {
    return {
      headers: {
        Authorization: UserSession.getTokenStorage()?.idToken || '',
      },
    }
  }

  static saveParticipation(payload) {
    return axiosInstance
      .post(`${endpoints.postParticipation}`, payload, this.getIdToken())
      .then(resp => resp.data)
  }

  static getCollegesTop({ concourseId, size = 10, page = 0 }) {
    return axiosInstance
      .get(
        `${endpoints.getCollegesTop}/${concourseId}?size=${size}&page=${page}`,
        this.getIdToken()
      )
      .then(resp => resp.data)
  }

  static getUsersTop({ concourseId, size = 10, page = 0 }) {
    return axiosInstance
      .get(
        `${endpoints.getUsersTop}/${concourseId}?size=${size}&page=${page}`,
        this.getIdToken()
      )
      .then(resp => resp.data)
  }

  static getUserPosition({ concourseId }) {
    return axiosInstance
      .get(
        `${endpoints.getUserTopPosition}/${concourseId}`,
        this.getIdToken()
      )
      .then(resp => resp.data)
  }

  static getUserCollegePosition({ concourseId }) {
    return axiosInstance
      .get(
        `${endpoints.getUserCollegeTopPosition}/${concourseId}`,
        this.getIdToken()
      )
      .then(resp => resp.data)
  }

  static getUserParticipation({ concourseId }) {
    return axiosInstance
      .get(
        `${endpoints.getUserParticipation}/${concourseId}`,
        this.getIdToken()
      )
      .then(resp => resp.data)
  }

  static getCollegeByCity({ cityId }) {
    return axiosInstance
      .get(`${endpoints.getCollegeByCity}/${cityId}`)
      .then(resp => resp.data)
  }
}
